import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LuUsers, LuUserPlus } from "react-icons/lu";
import { TbUserCog } from "react-icons/tb";

const BuyerSettings = () => {
  return (
    <>
      <div className="">
        <h1 className="text-xl font-semibold text-[#667085]">
          Buyer Settings
        </h1>
      </div>
      <div className="flex gap-10 px-10 mb-8 pt-4 ">
        <NavLink
          className={({ isActive }) =>
            isActive
              ? "flex items-center gap-2 text-blood text-lg font-semibold border-b-[3px] border-blood"
              : "flex items-center gap-2 text-[#667085] text-lg font-semibold"
          }
          to={"formsettings"}
        >
          <span>
            <LuUsers />
          </span>
          Form Settings
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive
              ? "flex items-center gap-2 text-blood text-lg font-semibold border-b-[3px] border-blood"
              : "flex items-center gap-2 text-[#667085] text-lg font-semibold"
          }
          to={"communicationsetting"}
        >
          {" "}
          <span>
            <LuUserPlus />
          </span>{" "}
          Communication Settings
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive
              ? "flex items-center gap-2 text-blood text-lg font-semibold border-b-[3px] border-blood "
              : "flex items-center gap-2 text-[#667085] text-lg font-semibold"
          }
          to={"viewsettings"}
        >
          {" "}
          <span>
            {" "}
            <TbUserCog />
          </span>{" "}
          View Settings{" "}
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive
              ? "flex items-center gap-2 text-blood text-lg font-semibold border-b-[3px] border-blood "
              : "flex items-center gap-2 text-[#667085] text-lg font-semibold"
          }
          to={"subscriptionsettings"}
        >
          {" "}
          <span>
            {" "}
            <TbUserCog />
          </span>{" "}
          Subscription Settings
        </NavLink>
      </div>
      <div>
        <Outlet />
      </div>
    </>
  );
};

export default BuyerSettings;
